import { useQuery } from 'react-query';
import { CHECK_TOKEN_QUERY_KEY, queryCheckToken } from './useCheckToken.query';

export const useCheckToken = () =>
  useQuery(CHECK_TOKEN_QUERY_KEY, () => queryCheckToken(), {
    retry: false,
    refetchOnWindowFocus: false,
    refetchOnMount: false,
    enabled: false,
  });
